/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IndiceReajusteAliases {
  CARD_INDICE = 'card-indice',
  DECK_INDICE_REAJUSTE = 'deck-indice-reajuste',
  FETCH_INDICE_REAJUSTE = 'fetch-indice-reajuste',
  FIELD_5 = 'field-5',
  FIELD_MONTH = 'field-month',
  FIELD_REAJUSTE = 'field-reajuste',
  FIELD_RELEASE_DATE = 'field-release-date',
  PANEL_INDICE_REAJUSTE = 'panel-indice-reajuste',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
}
export { IndiceReajusteAliases };
